import type { AttachmentKind } from '@/api/attachments'

const KB = 1024
const MB = 1024 * KB

export function formatByteSize(bytes: number): string {
  if (!Number.isFinite(bytes) || bytes < 0) return '–'
  if (bytes < KB) return `${bytes} B`
  if (bytes < MB) {
    const k = bytes / KB
    return `${k < 10 ? k.toFixed(1) : Math.round(k)} KB`
  }
  const m = bytes / MB
  return `${m < 10 ? m.toFixed(1) : Math.round(m)} MB`
}

export function kindLabel(kind: AttachmentKind): string {
  switch (kind) {
    case 'image':
      return 'Image'
    case 'screenshot':
      return 'Screenshot'
    case 'pdf':
      return 'PDF'
    case 'text':
      return 'Text'
    case 'other':
      return 'File'
  }
}
